import { useMemo } from 'react';
import { useInitialState } from '../contexts/InitialStateContext';
import { useParams } from 'react-router';
import { DEFAULT_STUDIO_CATEGORY_SLUG } from '../config';
import { useSearch } from './useSearch';

export const useSelectedCategory = () => {
  const initialState = useInitialState();
  const { isSearchActive } = useSearch();
  const { categorySlug: categorySlugParam } = useParams();

  const categorySlug = isSearchActive
    ? undefined
    : categorySlugParam ?? DEFAULT_STUDIO_CATEGORY_SLUG;

  const categories = useMemo(
    () => initialState.book?.categories ?? [],
    [initialState.book],
  );

  return useMemo(() => {
    return categories.find((a) => a.slug === categorySlug);
  }, [categories, categorySlug]);
};
